import { z } from 'zod';
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 200;
export const pageSchema = z.coerce.number().int().min(1).default(DEFAULT_PAGE);
export const pageSizeSchema = z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE);
export const sortDirectionSchema = z.enum(['asc', 'desc']);
/** Query params every paged list contract spreads into its input schema. */
export const paginationInputSchema = z.object({
    page: pageSchema,
    pageSize: pageSizeSchema,
});
/** Sorting params every sortable list contract spreads into its input schema. */
export const sortInputSchema = z.object({
    sortBy: z.string().min(1).optional(),
    sortDirection: sortDirectionSchema.default('asc'),
});
export const paginationMetaSchema = z.object({
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1),
    total: z.number().int().min(0),
    totalPages: z.number().int().min(0),
});
/** Wraps any item schema into the standard `{ items, meta }` list envelope. */
export const paginatedSchema = (itemSchema) => z.object({
    items: z.array(itemSchema),
    meta: paginationMetaSchema,
});
//# sourceMappingURL=pagination.schemas.js.map